export const SCREEN_BREAKPOINT_XL = 1200;
